import type { FormOptionType } from "@/components/ui/form/_types/type";

export function getOptionNumArray(
	startNum: number,
	step: number,
	length: number,
	options?: { suffix: string },
): FormOptionType[] {
	const suffix = options?.suffix ?? "";

	return Array.from(Array(length), (_, index) => {
		const numToString = String(index * step + startNum);

		return {
			id: numToString,
			label: numToString + suffix,
			value: numToString,
		} satisfies FormOptionType;
	});
}
